var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLeaveReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5417 41.4167H8.875",
    stroke: "#3B82F6",
    strokeWidth: 4.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5417 53.25H8.875",
    stroke: "#3B82F6",
    strokeWidth: 4.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1667 48.8126L51.7708 41.4167M51.7708 41.4167L44.375 48.8126M51.7708 41.4167V59.1667",
    stroke: "#3B82F6",
    strokeWidth: 4.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 17.75H39.9375M59.1667 17.75H52.5104",
    stroke: "#3B82F6",
    strokeWidth: 4.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1667 29.5833H28.1042M8.875 29.5833H15.5313",
    stroke: "#3B82F6",
    strokeWidth: 4.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLeaveReq);
export default __webpack_public_path__ + "static/media/newLeaveReq.9da9eab4a02a502c833c26b1da9c5c85.svg";
export { ForwardRef as ReactComponent };